import {defineField, defineType} from 'sanity'
import extractTextFromRichText from '../../utils/extractFromRichText'

export default defineType({
  title: 'Warranty',
  name: 'warranty',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Background image',
      name: 'backgroundImage',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Blocks',
      name: 'blocks',
      type: 'array',
      of: [
        {
          type: 'object',
          name: 'warrantyBlockItem',
          fields: [
            defineField({
              title: 'Title',
              name: 'title',
              type: 'string',
            }),
            defineField({
              title: 'Content',
              name: 'content',
              type: 'array',
              of: [
                {
                  type: 'block',
                  styles: [],
                  lists: [],
                  marks: {
                    decorators: [
                      {title: 'Strong', value: 'strong'},
                      {title: 'Emphasis', value: 'em'},
                    ],
                  },
                },
              ],
            }),
            defineField({
              title: 'Link',
              name: 'button',
              type: 'link',
            }),
          ],
          preview: {
            select: {
              title: 'title',
              content: 'content',
            },
            prepare({title, content}) {
              const subtitle = extractTextFromRichText(content) || 'Warranty Block'

              return {
                title,
                subtitle,
              }
            },
          },
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
      media: 'backgroundImage',
    },
    prepare({title, media}) {
      return {
        title,
        subtitle: 'Warranty',
        media,
      }
    },
  },
})
